import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';

const styles = (theme: Theme) =>
  createStyles({
    notificationProgressStatus: {
      height: theme.spacing(1),
      borderRadius: 5,
    },
  });

export default styles;
